import { BANK_ACCOUNT_PARAM } from '../constants';
/** The bank account the customer picked, as carried in the flow's query string. */
function getSelectedBankAccountId(search) {
    const bankAccountId = Number(new URLSearchParams(search).get(BANK_ACCOUNT_PARAM));
    return Number.isFinite(bankAccountId) && bankAccountId > 0
        ? bankAccountId
        : undefined;
}
export default getSelectedBankAccountId;
